import { render, staticRenderFns } from "./page_frame.vue?vue&type=template&id=05b27d1b&"
import script from "./page_frame.vue?vue&type=script&lang=js&"
export * from "./page_frame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports